import crud from './_crud'
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'
import Swal from 'sweetalert2'
import i18next from 'i18next'
const t = (key) => i18next.t(key)

const entity = 'client_route'
const actions = crud(
	'client_route',
	'la ruta del cliente',
	'las rutas del cliente'
)

const customSync = ({ deleteItems, updateItems, createItems }) => {
	return async (dispatch, getState) => {
		const state = getState()

		deleteItems.forEach((obj) => {
			if (typeof obj.employee_sub_id == 'object') {
				if (typeof obj.employee_sub_id == 'object') {
					obj.employee_sub_id = obj.employee_sub_id?.value
				}
				if (typeof obj.unit_sub_id == 'object') {
					obj.unit_sub_id = obj.unit_sub_id?.value
				}
			}
		})

		updateItems.forEach((obj) => {
			if (typeof obj.employee_sub_id == 'object') {
				obj.employee_sub_id = obj.employee_sub_id?.value
			}
			if (typeof obj.unit_sub_id == 'object') {
				obj.unit_sub_id = obj.unit_sub_id?.value
			}
			if (typeof obj.status == 'object') {
				obj.status = obj.status?.value
			}
		})

		createItems.forEach((obj) => {
			if (typeof obj.employee_sub_id == 'object') {
				if (typeof obj.employee_sub_id == 'object') {
					obj.employee_sub_id = obj.employee_sub_id?.value
				}
				if (typeof obj.unit_sub_id == 'object') {
					obj.unit_sub_id = obj.unit_sub_id?.value
				}
			}
		})

		let res = await callApi(`/${entity}/bulkSync`, {
			method: 'POST',
			body: JSON.stringify({
				deleteItems,
				updateItems,
				createItems,
			}),
			headers: {
				Authorization: state.app.user.token,
			},
			successMessage: t('Se sincronizaron las rutas del cliente correctamente.'),
		})

		let stored_item = res.body
		return dispatch(actions.load())
	}
}

const loadCurrentUnitRoutes = (item) => {
	return async (dispatch, getState) => {
		const state = getState()
		let res = await callApi(`/${entity}/utils/get_unit_current_routes`, {
			method: 'PUT',
			body: JSON.stringify(item),
			headers: {
				Authorization: state.app.user.token,
			},
		})

		dispatch({
			type: `UNIT_CURR_${entity.toUpperCase()}`,
			response: res.body,
		})

		return res.body
	}
}

const loadRouteStatus = (item) => {
	return async (dispatch, getState) => {
		const state = getState()
		let res = await callApi(`/${entity}/utils/get_route_status`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		dispatch({
			type: `LOAD_${entity.toUpperCase()}_STATUS`,
			response: res.body,
		})

		return res.body
	}
}

const loadClientRoutes = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/client_route/load_client_routes`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
			params: options?.params,
		})

		if (res && res.status === 200) {
			dispatch({
				type: `LOAD_CLIENT_ROUTES`,
				response: res.body,
			})
		} else {
			console.error('Error al cargar las rutas de los clientes:', res)
		}

		return res.body
	}
}

const updateClientRoutes = (item, options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/client_route/update_client_routes`, {
			method: 'PUT',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify(item),
			successMessage: t('Se actualizo la ruta del cliente de gasto correctamente.'),
		})
		showSuccessMessage(
			t('Las rutas de los clientes se actualizaron correctamente')
		)
		return res.body
	}
}

const loadClientRoutesByUsertype = ({ userType }) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/client_route/get_client_routes_by_usertype`, {
			method: 'GET',
			headers: {
				Authorization: state.app[userType].token,
			},
			params: {
				userType: userType,
				sys_company_id: state.app[userType].sys_company_id,
				[`${userType}_id`]: state.app[userType].id,
			},
		})

		dispatch({
			type: `GET_ALL_CLIENT_ROUTE_BY_USERTYPE`,
			payload: res.body,
		})

		return res.body
	}
}

const importRoutes = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/client_route/import_routes`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				options,
			}),
			successMessage: t('Se agreron las rutas del cliente correctamente.'),
		})
		showSuccessMessage(t('Se registraron las rutas del cliente correctamente'))
		return res.body
	}
}

const monitorRoute = (filters, routesOptions) => {
	return async (dispatch, getState) => {
		const state = getState()
		try {
			const res = await callApi(`/client_route/route_monitoring`, {
				method: 'POST',
				headers: {
					Authorization: state.app.user.token,
				},
				body: JSON.stringify({ filters, routesOptions }),
			})

			return res.body
		} catch (error) { }
	}
}

const createWialonGeofences = (rows, options = {}) => {
	return async (dispatch, getState) => {
		const state = getState()
		try {
			const res = await callApi(`/client_route/create_wialon_geofences`, {
				method: 'POST',
				json: true,
				body: JSON.stringify({
					items: rows,
					options,
				}),
				headers: {
					Authorization: state.app.user.token,
				},
				// successMessage: `Se crearon ${rows.length} geocercas en Wialon.`,
			})

			Swal.fire({
				title: t('¡Acción Realizada!'),
				text: `${t('Se crearon')} ${rows.length} ${t('geocercas en Wialon.')}`,
				icon: 'success',
				confirmButtonText: t('OK'),
				showCloseButton: true,
			}).then((result) => {
				if (result.isConfirmed) {
					window.location.reload()
				}
			})

			return res.body
		} catch (e) {
			return
		}
	}
}

const createClientRoute = (item, options = {}) => {
	return async (dispatch, getState) => {
		const state = getState()
		try {
			const res = await callApi(`/client_route/create_client_route`, {
				method: 'POST',
				json: true,
				body: JSON.stringify(item),
				headers: {
					Authorization: state.app.user.token,
				},
			})

			Swal.fire({
				title: t('¡Acción Realizada!'),
				text: t('Se creó la ruta correctamente.'),
				icon: 'success',
				confirmButtonText: t('OK'),
				showCloseButton: true,
			}).then((result) => {
				if (result.isConfirmed) {
					window.location.reload()
				}
			})

			return res.body
		} catch (e) {
			return
		}
	}
}

const updateClientRoute = (item) => {
	return async (dispatch, getState) => {
		const state = getState();
		try {
			const res = await callApi(`/client_route/update_client_route/${item.id}`, {
				method: 'PATCH',
				json: true,
				body: JSON.stringify(item),
				headers: {
					Authorization: state.app.user.token,
				},
			});

			Swal.fire({
				title: t('¡Acción Realizada!'),
				text: t('La ruta ha sido actualizada correctamente.'),
				icon: 'success',
				confirmButtonText: t('OK'),
				showCloseButton: true,
			});

			return res.body;
		} catch (e) {
			Swal.fire({
				title: t('¡Advertencia!'),
				text: t('No se pudo actualizar la ruta.'),
				icon: 'error',
				confirmButtonText: t('OK'),
				showCloseButton: true,
			});
			return;
		}
	};
};

const uploadStopImage = (routeId, stopId, file) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/client_route/${routeId}/stops/${encodeURIComponent(stopId)}/upload_image`, {
			method: 'PUT',
			json: false,
			headers: {
				Authorization: state.app.user.token,
			},
			body: {
				file,
			},
		})

		if (res.body?.error) {
			showErrorMessage({ error: res.body.error })
		}

		return res.body
	}
}

const deleteStopImage = (routeId, stopId) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/client_route/${routeId}/stops/${encodeURIComponent(stopId)}/image`, {
			method: 'DELETE',
			json: false,
			headers: {
				Authorization: state.app.user.token,
			},
		})

		if (res.body?.error) {
			showErrorMessage({ error: res.body.error })
		}

		return res.body
	}
}


const importStops = (rows) => {
	return async (dispatch, getState) => {
		const state = getState();
		try {
			const res = await callApi(`/client_route/import_stops`, {
				method: 'POST',
				json: true,
				body: JSON.stringify({ items: rows }),
				headers: { Authorization: state.app.user.token },
			});

			Swal.fire({
				title: t('¡Acción Realizada!'),
				text: `${t('Se importaron')} ${rows.length} ${t('geocercas.')}`,
				icon: 'success',
				confirmButtonText: t('OK'),
				showCloseButton: true,
			}).then((result) => {
				if (result.isConfirmed) {
					window.location.reload()
				}
			})
			return res.body;
		} catch (e) {
			return;
		}
	};
};

let customActions = {}
customActions = { ...customActions, customSync }
customActions = { ...customActions, loadCurrentUnitRoutes }
customActions = { ...customActions, loadRouteStatus }
customActions = { ...customActions, loadClientRoutes }
customActions = { ...customActions, updateClientRoutes, importRoutes, monitorRoute, createWialonGeofences, createClientRoute, updateClientRoute, importStops, uploadStopImage, deleteStopImage }

export default { ...actions, ...customActions, loadClientRoutesByUsertype }
